export class ApiEndPointsCompany {
    getCompanyListing = 'api/Core/GetCores';
    getFavoriteCompanyListing = 'api/CoreFavorite/GetFavoriteCores';
    getCompanyFeildList = 'api/Core/GetAllFolderFields';    
    saveCompanyFieldList = 'api/Core/AddCore';
    saveCompanyUserDetails = 'api/Core/UpdateCore';
    getCompanyUserDetails = 'api/Core/GetCoreDetail';
    getCompanyFieldColumn = 'api/CustomizedGridComponent/GetUserGridCustomizedSetting';
    updateCompanyFieldColumn = 'api/CustomizedGridComponent/UpdateUserGridCustomizationSetting';
    ReorderCompanyFieldColumn = 'api/CustomizedGridComponent/ReorderColumn';
    getImageUploadURL ='api/App/UploadProfilePic';
    getDefaultFilterFieldsList = 'api/Filter/GetDefaultFilterFields';
    CreateFilter = 'api/Filter/AddFillter'; 
    GetAllFillters = 'api/Filter/GetAllFillters'; 
    GetFilteredCompanys = 'api/Core/GetFilteredCores'; 
    DeleteCompanyTransaction = 'api/Core/DeleteCore'; 
    FavoriteCompanyTransaction ='api/CoreFavorite/AddCoreFavorite';
    FavoriteDeleteCompanyTransaction ='api/CoreFavorite/DeleteCoreFavorite';
}
